import { Controller } from 'stimulus'

// Highlights the link for the section being read, e.g. the Help page's side
// nav. The current link gets aria-current="location", and the indicator (a
// bar on the list's left border) slides to it as the page scrolls.
//
//   %nav{ data: { controller: "scrollspy" } }   (positioned, e.g. sticky)
//     %span{ data: { "scrollspy-target": "indicator" } }
//     %ul
//       %li= link_to "Section", "#section-id", data: { "scrollspy-target": "link" }
export default class extends Controller {
  static targets = ['link', 'indicator']

  connect() {
    this.sections = this.linkTargets.map((link) => document.getElementById(link.hash.slice(1)))
    this.onScroll = () => {
      if (this.frame) return
      this.frame = requestAnimationFrame(() => {
        this.frame = null
        this.update()
      })
    }
    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.onScroll)

    // A clicked link stays current - even if its section is short, or near
    // the bottom of the page - until the person scrolls themselves
    this.onClick = (event) => {
      const index = this.linkTargets.indexOf(event.target.closest('a'))
      if (index === -1) return
      this.clicked = index
      this.update()
    }
    this.onUserScroll = () => { this.clicked = null }
    this.element.addEventListener('click', this.onClick)
    this.userScrollEvents = ['wheel', 'touchmove', 'keydown']
    this.userScrollEvents.forEach((e) => window.addEventListener(e, this.onUserScroll, { passive: true }))

    this.update()
  }

  disconnect() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onScroll)
    this.element.removeEventListener('click', this.onClick)
    this.userScrollEvents.forEach((e) => window.removeEventListener(e, this.onUserScroll))
    if (this.frame) cancelAnimationFrame(this.frame)
  }

  // The current section is the clicked one, or else the last one whose
  // heading has scrolled above a line near the top of the screen - or the
  // last one at the very bottom of the page
  update() {
    this.markCurrent(this.clicked != null ? this.clicked : this.sectionInView())
  }

  sectionInView() {
    const line = Math.min(window.innerHeight / 4, 150)
    let current = 0
    this.sections.forEach((section, i) => {
      if (section && section.getBoundingClientRect().top <= line) current = i
    })
    const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2
    return atBottom ? this.sections.length - 1 : current
  }

  markCurrent(current) {
    this.linkTargets.forEach((link, i) => {
      if (i === current) {
        link.setAttribute('aria-current', 'location')
      } else {
        link.removeAttribute('aria-current')
      }
    })
    this.moveIndicator(this.linkTargets[current])
  }

  moveIndicator(link) {
    if (!this.hasIndicatorTarget || !link) return
    this.indicatorTarget.style.transform = `translateY(${link.offsetTop}px)`
    this.indicatorTarget.style.height = `${link.offsetHeight}px`
  }
}
